import { render, staticRenderFns } from "./budgetDetailInfo.vue?vue&type=template&id=22d58bd2&scoped=true&"
import script from "./budgetDetailInfo.vue?vue&type=script&lang=js&"
export * from "./budgetDetailInfo.vue?vue&type=script&lang=js&"
import style0 from "./budgetDetailInfo.vue?vue&type=style&index=0&id=22d58bd2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d58bd2",
  null
  
)

export default component.exports